import React, { useContext, useEffect, useState } from 'react';
import axios from "axios";
import { navigate } from "raviger";
import { Formik } from 'formik';
import {
  ButtonGroup,
  Card,
  Form as BootstrapForm,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowAltCircleLeft,
  faEyeSlash,
} from '@fortawesome/free-solid-svg-icons';
import * as Yup from 'yup';
import { TextInput } from './components/Form.js';
import ButtonSpinner from './components/ButtonSpinner.js';
import { AuthContext } from "./accounts/AccountsReducer";
import { SystemErrorContext } from './components/SystemError';

const OrganizationForm = ({ organization }) => {

  const { dispatch, state } = useContext(AuthContext);
  const { setShowSystemError } = useContext(SystemErrorContext);

  const [organizationData, setOrganizationData] = useState({
    liability_name: '',
    liability_short_name: '',
    verbal_liability_text: '',
  });

  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();

    const fetchOrganizationData = async () => {
      // Fetch Organization data.
      await axios.get('/incident/api/organization/?slug=' + organization, {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          setOrganizationData(response.data[0]);
        }
      })
      .catch(error => {
        if (!unmounted) {
          setShowSystemError(true);
        }
      });
    };
    fetchOrganizationData();

    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };
  }, [organization]);

  return (
    <Formik
      initialValues={organizationData}
      enableReinitialize={true}
      validationSchema={Yup.object({
        liability_name: Yup.string().required('Required').max(80, 'Must be 80 characters or less'),
        liability_short_name: Yup.string().required('Required').max(40, 'Must be 40 characters or less.'),
        verbal_liability_text: Yup.string().required('Required').max(1000, 'Must be 1000 characters or less'),
        watchduty_enabled: Yup.boolean()
      })}
      onSubmit={(values, { setSubmitting }) => {
          axios.put('/incident/api/organization/' + state.organization.id + '/', values)
          .then(function () {
            navigate('/' + organization + '/manage/organization');
          })
          .catch(error => {
            setShowSystemError(true);
          });
      }}
    >
      {form => (
        <Card border="secondary" className="mt-4 ml-auto mr-auto" style={{width:"80%", maxWidth:"80%"}}>
          <Card.Header as="h5" className="pl-3 d-flex flex-row justify-content-between">
            <div>
              <span style={{ cursor: 'pointer' }} onClick={() => navigate("/" + organization + '/manage/organization')} className="mr-3">
                <FontAwesomeIcon icon={faArrowAltCircleLeft} size="lg" inverse /></span>Edit Organization - {organizationData.name}
            </div>
          </Card.Header>
          <Card.Body>
            <BootstrapForm>
              <BootstrapForm.Row>
                <TextInput
                  type="text"
                  label="Liability Name"
                  name="liability_name"
                  id="liability_name"
                  xs="12"
                />
              </BootstrapForm.Row>
              <BootstrapForm.Row>
                <TextInput
                  type="text"
                  label="Liability Short Name"
                  name="liability_short_name"
                  id="liability_short_name"
                  xs="12"
                />
              </BootstrapForm.Row>
              <BootstrapForm.Row>
                <TextInput
                  type="text"
                  as="textarea"
                  rows={3}
                  label="Verbal Liability Text"
                  name="verbal_liability_text"
                  id="verbal_liability_text"
                  xs="12"
                />
              </BootstrapForm.Row>
            </BootstrapForm>
          </Card.Body>
          <ButtonGroup size="lg">
            <ButtonSpinner isSubmitting={form.isSubmitting} isSubmittingText="Saving..." className="btn btn-primary border" onClick={() => { form.submitForm() }}>Save</ButtonSpinner>
          </ButtonGroup>
        </Card>
      )}
    </Formik>
  );
};

export default OrganizationForm;
